import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountNotVerifyFormComponent } from '../../ui/account-not-verify/account-not-verify.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SignUpService } from '../../../signup/data-access/signup.service';
import { Subject, takeUntil } from 'rxjs';
import { CommunicationType } from '../../../reset-password/interfaces/reset-pwd.interface';

@Component({
  selector: 'equine-ui-nx-account-not-verify',
  standalone: true,
  imports: [CommonModule, AccountNotVerifyFormComponent],
  templateUrl: './account-not-verify.component.html',
  styleUrl: './account-not-verify.component.css',
})
export class AccountNotVerifyComponent implements OnInit, OnDestroy{
  appName!: string;
  constructor(
    private signUpService: SignUpService,
    private snackBar: MatSnackBar,
    private router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  email: any;
  loading: boolean = false;
  unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.appName = this.activatedRoute.snapshot.data["appName"]
    this.email = localStorage.getItem('signup-email');
    if(!this.email) {
      this.errorEmailNotFoundHandle();
    }
  }

  errorEmailNotFoundHandle() {
    this.snackBar.open(`Error: Connot process this request`,'Dismiss', {duration: 3000,panelClass: ['error-snackbar']});
  }
  
  navigateToSignupVerify() {
    this.router.navigate(['account','verify']);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
